import React from 'react';
import { Box, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import { ThemeProvider, createTheme, styled } from '@mui/material/styles';
import { invokeIfCallable } from '../../library/shared';
import { useThemes } from '../../components/Theme/theme';

function CustomInputBox({
  error,
  from,
  label,
  InputProps,
  name,
  placeholder,
  type,
  onChange,
  onBlur,
  state,
  autoFocus,
  icon,
  Icon,
  autoComplete,
  value,
  disabled,
  required,
  maxLength,
}) {
  const { theme } = useThemes();

  const themess = createTheme({
    palette: {
      mode: from ? 'light' : theme.palette.TmId.id.toString().includes('9'),
      primary: {
        main: '#75428C',
      },
      danger: {
        main: '#e55353',
      },
    },
  });
  return (
    <ThemeProvider theme={from ? themess : theme}>
      <Box sx={{ width: '100%', marginBottom: name !== 'password' || name !== 'newPassword' ? '10px' : '0px' }}>
        <TextField
          required={required}
          autoComplete={autoComplete}
          className="smaller-textfield1"
          size="small"
          id={name}
          name={name}
          type={type}
          autoFocus={autoFocus}
          placeholder={placeholder}
          label={label}
          disabled={disabled}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          inputProps={{ maxLength }}
          sx={{
            '.MuiFormLabel-asterisk': {
              color: 'danger.main',
              fontSize: '20px',
              fontWeight: 'bold',
            },
            '& .MuiInputBase-root': {
              // background: from ? "#fff" :  theme?.palette?.TmId.id.toString().includes("9") ? "#1E1E1E" : "transparent",
            },
            // '& input:-webkit-autofill': {
            //   '-webkit-box-shadow': from ? '0 0 0 30px white inset !important' : (theme?.palette?.TmId.id.toString().includes("9") ? '0 0 0 30px #1E1E1E inset !important' : '0 0 0 30px white inset !important'),
            //   '-webkit-text-fill-color': from ? '#000 !important' : (theme?.palette?.TmId.id.toString().includes("9") ? "#fff !important" : ""),
            // },
            '& input::-ms-reveal, & input::-ms-clear': {
              display: 'none',
            },
            '& input::-webkit-credentials-auto-fill-button': {
              visibility: 'hidden',
              display: 'none !important',
            },
            '& input:-webkit-autofill': {
              '-webkit-box-shadow': from ? '0 0 0 30px white inset !important' : '0 0 0 100px transparent inset !important',
              '-webkit-text-fill-color': from
                ? '#000 !important'
                : ` ${theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black'} !important`,
              transition: 'background-color 5000s ease-in-out 0s',
            },
            '& .MuiOutlinedInput-root': {
              '&:focus-within': {
                backgroundColor: from ? '' : '#ffb74d !important', // Change this to your preferred color
              },
            },
          }}
          InputLabelProps={{
            style: { color: from ? 'black' : theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black' }, // Change this color to the desired label color
          }}
          // autoComplete={autoComplete}
          // variant="outlined"
          fullWidth
          // InputProps={}
          InputProps={
            InputProps
              ? InputProps
              : {
                  startAdornment: icon && (
                    <InputAdornment position="start" className="icon">
                      {icon}
                    </InputAdornment>
                  ),
                  endAdornment: Icon && (
                    <InputAdornment position="end" className="iconpassword">
                      {Icon}
                    </InputAdornment>
                  ),
                  style: {
                    background: from ? '#fff' : theme?.palette?.TmId.id.toString().includes('9') ? '#1E1E1E' : 'transparent',
                    color: from ? 'black' : '',
                    fontSize: '14px',
                  },
                }
          }
          error={error}
          // helperText={error ? 'There is an error' : ''}
        />
        <span sx={{ fontSize: '12px', marginLeft: '10px' }}>
          <Typography sx={{ marginTop: '5px', marginLeft: '10px', fontSize: '12px', color: 'danger.main' }}>
            {state?.errorFields[name]}
          </Typography>
        </span>
        {name == 'password' && !state?.errorStatus[name] && state[name] == '' && (
          <span sx={{ fontSize: '12px', marginLeft: '10px' }}>
            {/* <Typography sx={{ marginTop: "5px", marginLeft: "10px", fontSize: "12px" }}>
                        Password Requires atleast one lowercase letter
                        and uppercase letters,
                        numbers and special characters, Whitespace not allowed and Minimum 8 characters
                    </Typography> */}
          </span>
        )}
      </Box>
    </ThemeProvider>
  );
}

export default CustomInputBox;
